(function(){
  function kill(){
    var el = document.getElementById('qa-trust-bar');
    if(el) el.parentNode.removeChild(el);
    var items = document.querySelectorAll('.qa-tb-item, .qa-tb-disclaimer');
    items.forEach(function(i){ i.parentNode.removeChild(i); });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', kill);
  } else {
    kill();
  }
  setTimeout(kill, 500);
  setTimeout(kill, 1500);
})();